export interface IFilterContentParams {
  pageNumber?: number;
  headline?: string;
  authors?: string;
  publishDateFrom?: Date;
  publishDateTo?: Date;
  pageSize?: number;
  contentListId?: string;
}
export class FilterContentParams implements IFilterContentParams {
  constructor(
    public pageNumber: number = 0,
    public pageSize?: number,
    public headline?: string,
    public authors?: string,
    public publishDateFrom?: Date,
    public publishDateTo?: Date,
    public contentListId?: string,
  ) {}
}
